export enum Status {
    ACTIVE = 'ACT',
    INACTIVE = 'IACT'
}
